import { render, staticRenderFns } from "./POrderFees.vue?vue&type=template&id=7ac4df5a"
import script from "./POrderFees.vue?vue&type=script&lang=js"
export * from "./POrderFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports